import React from 'react';
import PropTypes from 'prop-types';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

const sizes = {
    xsmall: {
        viewBox: '0 0 10 10',
        width: '10px',
        height: '10px',
        path: 'M1.46447 1.53553L5 5.07196M8.53553 8.6066L5 5.07196M5 5.07196L8.53553 1.53553M5 5.07196L1.46447 8.6066',
    },
    small: {
        viewBox: '0 0 12 12',
        width: '12px',
        height: '12px',
        path: 'M1 1L6 6.00075M11 11L6 6.00075M6 6.00075L11 1M6 6.00075L1 11',
    },
    medium: {
        viewBox: '0 0 16 16',
        width: '16px',
        height: '16px',
        path: 'M1 1L8 8.00076M15 15L8 8.00076M8 8.00076L15 1M8 8.00076L1 15',
    },
};

const Cross = ({ color = 'currentColor', size = 'small', height = '', width = '', viewBox = '', ...rest }) => {
    const selectedSize = sizes[size] || sizes.small;
    return (
        <Svg
            width={width || selectedSize.width}
            height={height || selectedSize.height}
            viewBox={viewBox || selectedSize.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path d={selectedSize.path} stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
        </Svg>
    );
};

Cross.propTypes = {
    color: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    size: PropTypes.oneOf(['xsmall', 'small', 'medium']),
    viewBox: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default Cross;
